module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "title": "Add Ship Level"
    },
    on: {
      "click": _vm.addChild
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55917794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shippinglvls/ShippingLvlAddButton.vue
// module id = 713
// module chunks = 0